import { render, staticRenderFns } from "./AuthorsSearch.vue?vue&type=template&id=2ae92bb6&scoped=true&"
import script from "./AuthorsSearch.vue?vue&type=script&lang=js&"
export * from "./AuthorsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae92bb6",
  null
  
)

export default component.exports